import services from './../../services/service'; // Service Class
import utility from './../../services/utility'; // Utility Class
// import SettingsLib from './../../components/tools/settings.vue'; // Settings
let service = new services();
let util = new utility();

export default {
  name: "MainHeader",
  data() {
      return {
        user: '', 
        user_slug: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false
      }
  },
  components:{
    // 'c-settings':SettingsLib,
  },

  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    

    setMarketLocal(){
        //quick settings for get store from froage
        let self = this;
        setTimeout(function(){ 
           localforage.getItem(util.market_store, function(err, value) { 
               self.market = value; 
            }); 
        },1500);

    },

    // mountid: (function() { console.log("hy6qdd")
    slide(){console.log("hy6qdd111")
      // "use strict";
          /*-----------------
          MAIN SLIDER
      -----------------*/
      $('.main-slider').bxSlider({
          pagerCustom: '.pager-container',
          controls: false,
          easing: 'ease-in',
          speed: 800,
          auto: true,
          pause: 6000
      });

      /*-------------
          VIDEO
      -------------*/
      $('#video .radial-progress').on('click', function() {
          $('#video > iframe').show();
      });

      /*----------------
          TOOLTIP
      ----------------*/
      $('.tooltip').tooltipster({
          animation: 'grow',
          position: 'bottom'
      });

      /*-----------------
          RESIZE IMAGE
      -----------------*/
      $("figure.imgLiquidFill").imgLiquid();

      /*----------------
          IMAGE POPUP
      ----------------*/
      $('ul.dishes > li > div > a').magnificPopup({
          type: 'image',
          removalDelay: 300,
          mainClass: 'mfp-fade',
          image: {
              tError: 'The image could not be loaded.'
          },
          closeMarkup: '<span class="mfp-close"></span>'
      });
    }
  // })
    
  },
  created: function() {
    // window.addEventListener('load', this.mountid());
    // window.addEventListener('load', this.slide());
    // this.slide();
    this.checkLoggedIn();
    this.setMarketLocal();
    
  },
  destroyed () {
      //destroy the load event to load all extended javascripts
      // window.removeEventListener('load', this.mountid);
  }
}
 


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js